import React from "react";
import leftArrow from "../../../assets/leftArrow.svg";
import twitterIcon from "../../../assets/twitter_2.svg";
import globeIcon from "../../../assets/globe_2.svg";
import ownerImg from "../../../assets/ownerImg.png";
import styles from "./Intro.module.scss";

const Intro = () => {
  return (
    <section className={styles.container}>
      <div className={styles.top}>
        <div className={styles.leftArrow}>
          <img src={leftArrow} alt="go-back" />
        </div>
        <h1>My Profile</h1>
        <div className={styles.socials}>
          <div className={styles.social}>
            <img src={twitterIcon} alt="twitter" />
          </div>
          <div className={styles.social}>
            <img src={globeIcon} alt="globe" />
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <img src={ownerImg} alt="owner" />
        <h5>Tyler Smith</h5>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit at
          accumsan montes, luctus duis. Aliquet vitae augue amet.
        </p>
      </div>
    </section>
  );
};

export default Intro;
